export default defineNuxtPlugin(async () => {
  const { fetchData, regions } = useStaticData();
  await fetchData();

  const headers = useRequestHeaders();
  const url = useRequestURL();

  if (url.pathname == "/redirect") {
    throw new Error("Ignore /redirect requests!");
  }
  if (headers && headers["user-agent"]) {
    const userAgent = headers["user-agent"];
    const isBot = /semrush|ahrefsbot/i.test(userAgent);
    if (isBot) {
      throw new Error("Ignore bot requests!");
    }
  }

  let hostname = url.hostname;
  hostname = hostname.split(".")[0];

  useState("hostname", () => hostname);
  const regionId = useState("regionId", () => 0);
  const region = regions.value?.find((r) =>
    r.attributes.url.includes(hostname),
  );
  regionId.value = region?.id ?? 0;
});
